import { useTranslation } from 'react-i18next';

import { apiRoutes } from 'constants/routes';
import { useMutation } from '@tanstack/react-query';
import { showNotification } from 'shared/ui/Notification';
import { useInternalApiRequest } from 'shared/hooks/useInternalApiRequest';
import { useCreatePerformanceTimer } from 'shared/hooks/useCreatePerformanceTimer';
import { InternalApiRequestError } from 'shared/hooks/useInternalApiRequest/types';

import { SendPaymentChangeEmailInitialResponse, SendPaymentChangeEmailRequest } from './types';

export const useMutationSendShopifyEmail = () => {
  const { t } = useTranslation(['modalWindows']);
  const request = useInternalApiRequest();

  const createPerformanceTimer = useCreatePerformanceTimer();
  const timer = createPerformanceTimer('updatePaymentMethod');

  return useMutation<
    SendPaymentChangeEmailInitialResponse,
    InternalApiRequestError,
    SendPaymentChangeEmailRequest
  >({
    mutationFn: ({ store, paymentMethodId }: SendPaymentChangeEmailRequest) =>
      request({
        method: 'POST',
        url: apiRoutes.members.sendPaymentChangeEmail({ store }, { paymentMethodId })
      }),
    onSuccess: (_response, { onClose }) => {
      onClose();
      showNotification('mutationSuccess', {
        title: t('paymentMethod.successTitle'),
        description: t('paymentMethod.successMessage')
      });
      timer.success();
    },
    onError: (error) => {
      showNotification('mutationError', {});
      timer.failure(error);
    }
  });
};
